import 'css-chunksrc/client/scenes/projectModelCreationFromProject/styles.scss';export default {
  "form": "_form_1lplc_1",
  "buttons": "_buttons_1lplc_10"
};